import React from "react";

export const UserContext = React.createContext({
	token: null,
	user: null,
	setUser: () => { },
	logout: () => { },
});
